import type { FaireProductEntity } from "../../entity_types/product";

export const p_hxfwuf9zh5: FaireProductEntity = {
  token: "p_hxfwuf9zh5",
  type: "product",
  name: "Good In Bed Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/7accb66943ad82da46f55bf639e3c03aa2bfb2e03dfc4ca2f8b14edc8853490d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7fb0de09cb936b5997326568f9dfeeee4dd0f3298ea2121eb8b27b99a3bb33da.jpeg",
    "https://cdn.faire.com/fastly/caf59a28890a3249dea566cc33725a38ef6074609e7c57075087cd6304376e6b.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/46d808778d968a6dd124ae83ebe68b9d86bc2e5e048fbc421f6009de421d8a67.jpeg",
    "https://cdn.faire.com/fastly/5ffcea978517fa1a395b5f2430cb60105848a757752e96b1d6a4737ce7422b8f.jpeg",
    "https://cdn.faire.com/fastly/f36581312e79c6ac248623a5a6592880c3f750445a77069e7ef3311701a952f1.jpeg",
    "https://cdn.faire.com/fastly/9e832b9764620b883b226c04bd48c43b8d3dfe5e5301d5580269e1c416e84b3d.jpeg"
  ],
  priceDollars: 6.75,
  description: "Sometimes it's best you announce your talents before you even kick off your socks.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:26.018Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
